<!--

사천시(gnsc) 프로젝트에서 사용하는 부서명 검색 컴포넌트

업체명 이름 중 "과" 가 포함되어 있는 부서명만 필터링하여 보여주고
부서명을 선택하면(실제 db에 존재하는 업체),
문서의 stdInfo.section 에 저장된 부서명이 (단순 텍스트) 선택한 부서와, 그 하위 부서의 부서명에 포함되어 있는 문서만 보여주기 위해 제작된 컴포넌트

-->
<template>
  <div class="search-base search-container">
    <search-label-body :label="label" :label-hidden="!label" :columns="gridTemplateColumns">
      <div>
        <vs-select
          class="w-full xl:w-48"
          autocomplete
          :disabled="readonly"
          v-model="companyName"
          @change="onChange"
          @click="scrollToSelected"
          not-data="검색 결과가 없습니다"
        >
          <vs-select-item v-for="(company, index) in companyList" :key="index" :text="company.text" :value="company.value" />
        </vs-select>
      </div>
    </search-label-body>
  </div>
</template>

<script>
import SearchLabelBody from "@/views/list/components/base/SearchLabelBody.vue";
import CompanySelector from "@/components/selector/CompanySelector.vue";

export default {
  name: "SearchSelectCompanyName",
  components: {
    CompanySelector,
    SearchLabelBody,
  },
  props: {
    label: {
      default: "부서명",
      type: String,
    },
    value: [String, Number],
    readonly: Boolean,
    query: {
      type: Object,
      default: () => {
        return {
          cName: "",
        };
      },
    },
    options: Object,
  },
  watch: {
    value(value) {
      this.companyName = value;
    },
  },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
    isMobile() {
      return !(this.$store.state.verticalNavMenuWidth === "default");
    },
    initData() {
      const defaultValue = this.options && this.options["default"] ? this.options["default"] : this.companyList.length > 0 ? this.companyList[0].value : "";
      const _query_keys = Object.keys(this.query);
      const query = this.$route.query;
      const companyName = query[_query_keys[0]];
      return {
        companyName: companyName || defaultValue,
      };
    },
    gridTemplateColumns() {
      return this.options && this.options["gridTemplateColumns"];
    },
    companyList() {
      const resultList = [
        {
          value: "",
          text: "전체",
          company_path: "",
        },
      ];
      /**
       * 다음 항목들을 선택지에 직접 입력한다.
       * 기획예산담당관
       * 공보감사담당관
       * 우주항공과
       * 투자유치산단과
       * 지역경제과
       * 정보통신과
       * 관광정책과
       * 문화예술과
       * 해양수산과
       * 체육진흥과
       * 행정과
       * 민원지적과
       * 세무과
       * 회계과
       * 주민돌봄과
       * 노인장애인과
       * 여성가족과
       * 환경보호과
       * 재난안전과
       * 도로과
       * 교통행정과
       * 녹지공원과
       * 도시과
       * 건축과
       * 건설과
       * 도시재생과
       * 보건위생과, 건강증진과, 질병관리과
       * 농축산과, 미래농업과, 기술지원과
       * 평생학습관
       * 환경사업소
       * 상하수도사업소
       * 사천읍
       * 정동면
       * 사남면
       * 용현면
       * 축동면
       * 곤양면
       * 곤명면
       * 서포면
       * 동서동
       * 선구동
       * 동서금동
       * 벌용동
       * 향촌동
       * 남양동
       * 신수출장소
       */

      const directInputList = [
        "기획예산담당관",
        "공보감사담당관",
        "우주항공과",
        "투자유치산단과",
        "지역경제과",
        "정보통신과",
        "관광정책과",
        "문화예술과",
        "해양수산과",
        "체육진흥과",
        "행정과",
        "민원지적과",
        "세무과",
        "회계과",
        "주민돌봄과",
        "노인장애인과",
        "여성가족과",
        "환경보호과",
        "재난안전과",
        "도로과",
        "교통행정과",
        "녹지공원과",
        "도시과",
        "건축과",
        "건설과",
        "도시재생과",
        "보건위생과",
        "건강증진과",
        "질병관리과",
        "농축산과",
        "미래농업과",
        "기술지원과",
        "평생학습관",
        "환경사업소",
        "상하수도사업소",
        "사천읍",
        "정동면",
        "사남면",
        "용현면",
        "축동면",
        "곤양면",
        "곤명면",
        "서포면",
        "동서동",
        "선구동",
        "동서금동",
        "벌용동",
        "향촌동",
        "남양동",
        "신수출장소",
      ];

      directInputList.forEach((item) => {
        resultList.push({
          value: item,
          text: item,
          company_path: "",
        });
      });

      return resultList;

      //   const companyTree = this.$store.state.company.companyTree
      //   if (companyTree && companyTree.length > 0) {

      //     // 업체트리가 1개일 경우, 해당 업체만 필터링 ("전체" 선택지를 사용 하지 않는다)
      //     if (companyTree.length === 1) {
      //       const company = companyTree[0]
      //       return [
      //         {
      //           value: '',
      //           text: '전체',
      //           company_path: '',
      //         }, {
      //           value: company.descendant.com_name,
      //           text: company.descendant.com_name,
      //           company_path: company.company_path,
      //         }
      //       ]
      //     } else  {
      //       resultList.push(...companyTree.filter((company) => {
      //         // tree 구조에서 3단계에 해당하는 업체가 "과" 업체로 분류되어 있으므로,
      //         // 3단계에 해당하는 업체와, 기획예산담당관, 공보감사담당관만 필터링
      //         // gnsc
      //         const companyPath = company.company_path.split('/').filter((path) => path !== '')
      //         if (
      //           companyPath.length === 3
      //           || company.descendant.com_name === '기획예산담당관'
      //           || company.descendant.com_name === '공보감사담당관') {
      //           return company
      //         }
      //       })
      //         .map((company) => {
      //           return {
      //             value: company.descendant.com_name,
      //             text: company.descendant.com_name,
      //             company_path: company.company_path,
      //           }
      //         })
      //         .sort((a, b) => {
      //           // 공보감사담당관, 기획예산담당관 순서로 정렬
      //           if (a.text === '기획예산담당관' && b.text === '공보감사담당관') {
      //             return 1
      //           }
      //           if (b.text === '기획예산담당관' && a.text === '공보감사담당관') {
      //             return -1
      //           }

      //           // 공보감사담당관, 기획예산담당관을 맨 위로 정렬
      //           if (a.text === '기획예산담당관' || a.text === '공보감사담당관') {
      //             return -1
      //           }
      //           if (b.text === '기획예산담당관' || b.text === '공보감사담당관') {
      //             return 1
      //           }

      //           // 나머지는 내림차순으로 정렬
      //           return a.text < b.text ? -1 : a.text > b.text ? 1 : 0
      //         }))
      //     }
      //   }

      //   return resultList;
    },
  },
  data() {
    return {
      companyName: "",
    };
  },
  created() {
    this.companyName = this.initData.companyName;
    this.change(this.companyName);
  },
  methods: {
    change(data) {
      this.$emit("input", data);
    },
    onChange(companyName) {
      // Event 객체가 아닌 경우에만 처리
      if (typeof companyName !== 'object' || companyName === null) {
        this.change(companyName);
      } else {
        // clear 버튼 클릭 등 Event 객체인 경우 빈 문자열
        this.change('');
      }
    },
    scrollToSelected() {
      this.$nextTick(() => {
        // 드롭다운 애니메이션 완료 대기
        setTimeout(() => {
          // 현재 선택된 텍스트 찾기
          const selected = this.companyList.find(
            c => c.value === this.companyName
          );
          if (!selected) return;

          const selectedText = selected.text;

          // Vuesax 옵션 리스트
          const list = document.querySelector('.vs-select--options');
          if (!list) return;

          // 선택된 항목(li)
          const item = list.querySelector(`[data-text="${selectedText}"]`);
          if (!item) return;

          // 드롭다운 내부만 스크롤 (페이지 스크롤 방지)
          const itemTop = item.offsetTop;
          const listHeight = list.clientHeight;
          const itemHeight = item.clientHeight;

          // 항목이 중앙에 오도록 스크롤
          list.scrollTop = itemTop - (listHeight / 2) + (itemHeight / 2);
        }, 50);
      });
    }
  }
};
</script>
